import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { getCourseRecommend, getCourseUrl, saveCourseRecommend, saveCourseUrl } from "@/api/config";
import { isValidURL } from "@/utils/validate";
var RedirectType;
(function (RedirectType) {
    RedirectType[RedirectType["BUFFET"] = 1] = "BUFFET";
    RedirectType[RedirectType["LINK"] = 2] = "LINK";
})(RedirectType || (RedirectType = {}));
let ConfigManage = class ConfigManage extends Vue {
    constructor() {
        super(...arguments);
        this.redirectTypes = [
            {
                name: "跳转链接",
                value: RedirectType.LINK,
            },
            {
                name: "跳转小卖部",
                value: RedirectType.BUFFET,
            },
        ];
        this.redirect = {
            type: RedirectType.LINK,
            path: "",
        };
        this.isRedirectLoading = true;
        this.recommends = [
            {
                copywrite: '',
                productId: ''
            },
            {
                copywrite: '',
                productId: ''
            },
            {
                copywrite: '',
                productId: ''
            }
        ];
        this.isRecommendLoading = true;
    }
    created() {
        this.initRedirectData();
        this.initRecommend();
    }
    // 初始化跳转连接数据
    async initRedirectData() {
        try {
            this.isRedirectLoading = true;
            const res = await getCourseUrl();
            if (res.data.status !== 200)
                return;
            const data = res.data.data;
            if (!data)
                return;
            this.redirect.path = data.url;
        }
        catch (error) { }
        finally {
            this.isRedirectLoading = false;
        }
    }
    // 切换跳转类型
    handleRedirectTypeChange(type) {
        if (type == 1) {
            this.redirect.path = "";
        }
        else {
            this.initRedirectData();
        }
    }
    // 点击保存按钮
    async handleRedirectSave() {
        // 跳转小卖部暂不开放
        if (this.redirect.type === RedirectType.BUFFET)
            return;
        if (this.redirect.path !== "" && !isValidURL(this.redirect.path)) {
            return this.$message.error("请输入合法的URL");
        }
        try {
            this.isRedirectLoading = true;
            const res = await saveCourseUrl(this.redirect.type, encodeURIComponent(this.redirect.path));
            if (res.data.status !== 200)
                return;
            this.$message.success("保存成功");
            // this.initRedirectData();
        }
        catch (error) { }
        finally {
            this.isRedirectLoading = false;
        }
    }
    async initRecommend() {
        try {
            this.isRecommendLoading = true;
            const res = await getCourseRecommend();
            if (res.data.status !== 200)
                return;
            const data = res.data.data;
            if (!data)
                return;
            this.recommends.forEach((r, ridx) => {
                const _r = data[ridx];
                if (_r) {
                    r.copywrite = _r.copywriting;
                    r.productId = _r.productId;
                }
                else {
                    r.copywrite = '';
                    r.productId = '';
                }
            });
        }
        catch (error) { }
        finally {
            this.isRecommendLoading = false;
        }
    }
    async handleRecommendSave() {
        const hasInvalidData = this.recommends.some(r => Number(!!r.copywrite) ^ Number(!!r.productId));
        if (hasInvalidData) {
            return this.$message.error('请同时填写提醒和商品ID，或同时不填');
        }
        const data = this.recommends.map(r => ({
            copywriting: r.copywrite,
            productId: r.productId
        }));
        try {
            this.isRecommendLoading = true;
            const res = await saveCourseRecommend(data);
            if (res.data.status !== 200)
                return;
            this.$message.success("保存成功");
            // this.initRecommend();
        }
        catch (error) { }
        finally {
            this.isRecommendLoading = false;
        }
    }
};
ConfigManage = tslib_1.__decorate([
    Component({
        name: "ConfigManage",
    })
], ConfigManage);
export default ConfigManage;
